var icon = require('vue-svgicon')
icon.register({
  'ks-icon-email': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M102.37 48.11V35.24L63.77 61l-38.6-25.76v12.87l38.6 25.73 38.6-25.73m0-25.73a12.86 12.86 0 0 1 12.86 12.86v57.89A12.87 12.87 0 0 1 102.37 106h-77.2a12.86 12.86 0 0 1-12.86-12.87V35.24a12.86 12.86 0 0 1 12.86-12.86h77.2"/>'
  }
})
